import { DietType, FoodType, Currency, MacrosPreset, Country, PlanType } from '@calo/types';
export const CALO_FOOD_TYPE_PRICING = {
    [DietType.lowCarb]: {
        [FoodType.breakfast]: {
            [Currency.BHD]: 2.5,
            [Currency.SAR]: 25,
            [Currency.AED]: 30,
            [Currency.KWD]: 2,
            [Currency.OMR]: 2.5
        },
        [FoodType.lunch]: {
            [Currency.BHD]: 3,
            [Currency.SAR]: 30,
            [Currency.AED]: 35,
            [Currency.KWD]: 2.5,
            [Currency.OMR]: 3
        },
        [FoodType.dinner]: {
            [Currency.BHD]: 3,
            [Currency.SAR]: 30,
            [Currency.AED]: 35,
            [Currency.KWD]: 2.5,
            [Currency.OMR]: 3
        },
        [FoodType.coffee]: {
            [Currency.BHD]: 1.6,
            [Currency.SAR]: 16,
            [Currency.AED]: 16,
            [Currency.KWD]: 1.6,
            [Currency.OMR]: 1.6
        },
        [FoodType.juice]: {
            [Currency.BHD]: 1.5,
            [Currency.SAR]: 15,
            [Currency.AED]: 15,
            [Currency.KWD]: 1.5,
            [Currency.OMR]: 1.5
        },
        [FoodType.snack]: {
            [Currency.BHD]: 1.5,
            [Currency.SAR]: 15,
            [Currency.AED]: 17,
            [Currency.KWD]: 1.5,
            [Currency.OMR]: 1.5
        },
        [FoodType.dessert]: {
            [Currency.BHD]: 7.27,
            [Currency.SAR]: 69.57,
            [Currency.AED]: 76.19,
            [Currency.KWD]: 7.0,
            [Currency.OMR]: 76.19
        }
    },
    [DietType.balanced]: {
        [FoodType.breakfast]: {
            [Currency.BHD]: 2,
            [Currency.SAR]: 20,
            [Currency.AED]: 25,
            [Currency.KWD]: 1.5,
            [Currency.OMR]: 2
        },
        [FoodType.lunch]: {
            [Currency.BHD]: 3,
            [Currency.SAR]: 30,
            [Currency.AED]: 35,
            [Currency.KWD]: 2.5,
            [Currency.OMR]: 3
        },
        [FoodType.dinner]: {
            [Currency.BHD]: 3,
            [Currency.SAR]: 30,
            [Currency.AED]: 35,
            [Currency.KWD]: 2.5,
            [Currency.OMR]: 3
        },
        [FoodType.coffee]: {
            [Currency.BHD]: 1.6,
            [Currency.SAR]: 16,
            [Currency.AED]: 16,
            [Currency.KWD]: 1.6,
            [Currency.OMR]: 1.6
        },
        [FoodType.juice]: {
            [Currency.BHD]: 1.5,
            [Currency.SAR]: 15,
            [Currency.AED]: 15,
            [Currency.KWD]: 1.5,
            [Currency.OMR]: 1.5
        },
        [FoodType.snack]: {
            [Currency.BHD]: 1,
            [Currency.SAR]: 10,
            [Currency.AED]: 12,
            [Currency.KWD]: 1,
            [Currency.OMR]: 1
        },
        [FoodType.dessert]: {
            [Currency.BHD]: 7.27,
            [Currency.SAR]: 69.57,
            [Currency.AED]: 76.19,
            [Currency.KWD]: 7.0,
            [Currency.OMR]: 76.19
        }
    },
    [DietType.vegetarian]: {
        [FoodType.breakfast]: {
            [Currency.BHD]: 2,
            [Currency.SAR]: 20,
            [Currency.AED]: 25,
            [Currency.KWD]: 1.5,
            [Currency.OMR]: 2
        },
        [FoodType.lunch]: {
            [Currency.BHD]: 3,
            [Currency.SAR]: 30,
            [Currency.AED]: 35,
            [Currency.KWD]: 2.5,
            [Currency.OMR]: 3
        },
        [FoodType.dinner]: {
            [Currency.BHD]: 3,
            [Currency.SAR]: 30,
            [Currency.AED]: 35,
            [Currency.KWD]: 2.5,
            [Currency.OMR]: 3
        },
        [FoodType.coffee]: {
            [Currency.BHD]: 1.6,
            [Currency.SAR]: 16,
            [Currency.AED]: 16,
            [Currency.KWD]: 1.6,
            [Currency.OMR]: 1.6
        },
        [FoodType.juice]: {
            [Currency.BHD]: 1.5,
            [Currency.SAR]: 15,
            [Currency.AED]: 15,
            [Currency.KWD]: 1.5,
            [Currency.OMR]: 1.5
        },
        [FoodType.snack]: {
            [Currency.BHD]: 1,
            [Currency.SAR]: 10,
            [Currency.AED]: 12,
            [Currency.KWD]: 1,
            [Currency.OMR]: 1
        },
        [FoodType.dessert]: {
            [Currency.BHD]: 7.27,
            [Currency.SAR]: 69.57,
            [Currency.AED]: 76.19,
            [Currency.KWD]: 7.0,
            [Currency.OMR]: 76.19
        }
    }
};
export const CALO_BH_FOOD_TYPE_MAGIC_PRICING = {
    [DietType.lowCarb]: {
        [FoodType.breakfast]: {
            [Currency.BHD]: 2
        },
        [FoodType.lunch]: {
            [Currency.BHD]: 2
        },
        [FoodType.dinner]: {
            [Currency.BHD]: 2
        },
        [FoodType.coffee]: {
            [Currency.BHD]: 1.6
        },
        [FoodType.juice]: {
            [Currency.BHD]: 1.5
        },
        [FoodType.snack]: {
            [Currency.BHD]: 1.5
        },
        [FoodType.dessert]: {
            [Currency.BHD]: 7.27
        }
    },
    [DietType.balanced]: {
        [FoodType.breakfast]: {
            [Currency.BHD]: 1.5
        },
        [FoodType.lunch]: {
            [Currency.BHD]: 2
        },
        [FoodType.dinner]: {
            [Currency.BHD]: 2
        },
        [FoodType.coffee]: {
            [Currency.BHD]: 1.6
        },
        [FoodType.juice]: {
            [Currency.BHD]: 1.5
        },
        [FoodType.snack]: {
            [Currency.BHD]: 1
        },
        [FoodType.dessert]: {
            [Currency.BHD]: 7.27
        }
    },
    [DietType.vegetarian]: {
        [FoodType.breakfast]: {
            [Currency.BHD]: 1.5
        },
        [FoodType.lunch]: {
            [Currency.BHD]: 2
        },
        [FoodType.dinner]: {
            [Currency.BHD]: 2
        },
        [FoodType.coffee]: {
            [Currency.BHD]: 1.6
        },
        [FoodType.juice]: {
            [Currency.BHD]: 1.5
        },
        [FoodType.snack]: {
            [Currency.BHD]: 1
        },
        [FoodType.dessert]: {
            [Currency.BHD]: 7.27
        }
    }
};
export const MEALO_FOOD_TYPE_PRICING = {
    [DietType.balanced]: {
        [FoodType.breakfast]: {
            [Currency.BHD]: 1.5
        },
        [FoodType.lunch]: {
            [Currency.BHD]: 2
        },
        [FoodType.dinner]: {
            [Currency.BHD]: 2
        },
        [FoodType.snack]: {
            [Currency.BHD]: 0.5
        },
        [FoodType.dessert]: {
            [Currency.BHD]: 7.27
        }
    }
};
export const MACROS_DISTRIBUTION = {
    [MacrosPreset.highProtein]: {
        protein: {
            min: 0.45,
            max: 0.55
        },
        carbs: {
            min: 0.25,
            max: 0.35
        },
        fat: {
            min: 0.15,
            max: 0.25
        }
    },
    [MacrosPreset.highFat]: {
        protein: {
            min: 0.25,
            max: 0.35
        },
        carbs: {
            min: 0.05,
            max: 0.15
        },
        fat: {
            min: 0.45,
            max: 0.65
        }
    },
    [MacrosPreset.highCarbs]: {
        protein: {
            min: 0.35,
            max: 0.45
        },
        carbs: {
            min: 0.35,
            max: 0.45
        },
        fat: {
            min: 0.15,
            max: 0.25
        }
    },
    [MacrosPreset.evenSplit]: {
        protein: {
            min: 0.28,
            max: 0.38
        },
        carbs: {
            min: 0.28,
            max: 0.38
        },
        fat: {
            min: 0.28,
            max: 0.38
        }
    }
};
export const CALO_PLAN_MIN_PRICE_WEEKLY = {
    [Country.AE]: 70,
    [Country.SA]: 70,
    [Country.BH]: 5,
    [Country.KW]: 5,
    [Country.OM]: 5
};
export const CALO_PLAN_MIN_PRICE_MONTHLY = {
    [Country.AE]: 60,
    [Country.SA]: 60,
    [Country.BH]: 4,
    [Country.KW]: 4,
    [Country.OM]: 4
};
export const CALO_PLAN_RAMADAN_DISCOUNT = {
    [Currency.BHD]: {
        [DietType.balanced]: {
            [PlanType.ramadan]: 1,
            [PlanType.futoor]: 1,
        },
        [DietType.vegetarian]: {
            [PlanType.ramadan]: 1,
            [PlanType.futoor]: 1,
        },
        [DietType.lowCarb]: {
            [PlanType.ramadan]: 1.5,
            [PlanType.futoor]: 1.5,
        }
    },
    [Currency.SAR]: {
        [DietType.balanced]: {
            [PlanType.ramadan]: 10,
            [PlanType.futoor]: 10,
        },
        [DietType.vegetarian]: {
            [PlanType.ramadan]: 10,
            [PlanType.futoor]: 10,
        },
        [DietType.lowCarb]: {
            [PlanType.ramadan]: 15,
            [PlanType.futoor]: 15,
        }
    },
    [Currency.AED]: {
        [DietType.balanced]: {
            [PlanType.ramadan]: 16,
            [PlanType.futoor]: 1,
        },
        [DietType.vegetarian]: {
            [PlanType.ramadan]: 16,
            [PlanType.futoor]: 1,
        },
        [DietType.lowCarb]: {
            [PlanType.ramadan]: 16,
            [PlanType.futoor]: 11,
        }
    },
    [Currency.KWD]: {
        [DietType.balanced]: {
            [PlanType.ramadan]: 1.5,
            [PlanType.futoor]: 1,
        },
        [DietType.vegetarian]: {
            [PlanType.ramadan]: 1.5,
            [PlanType.futoor]: 1,
        },
        [DietType.lowCarb]: {
            [PlanType.ramadan]: 2,
            [PlanType.futoor]: 1.5,
        }
    }
};
